export default __webpack_public_path__ + "static/media/smalltelegram_line.166e9fea.svg";